import React, {useContext} from "react";

import MainTitle from "../../common/MainTitle";
import MainButton from "../../common/MainButton";
import lbl from "../../../data/Labels.json";
import {PopUpContext} from "../../../contexts/popUpContext";

const BenefitDetails = ({ data }) => {
    const { togglePopUp, popUp } = useContext(PopUpContext);

  return data ? (
    <div className="report-table-area">
          <div className="teacher-benefit-detail-area">
              <div className={"right-content"} style={{float: "right", width: "80%"}}>
                  <MainTitle title={data?.benefit_type}/>
              </div>
              <div className={"left-content"}>
                  <MainButton
                      type="pen"
                      title={lbl.EditBenefits}
                      handleClick={() => togglePopUp({ form: "teacher-benefit-form", edit: data})}
                  />
                  <MainButton
                      type="delete"
                      title={lbl.Delete}
                      handleClick={() => togglePopUp({ form: "delete", route: "benefits/teacher", id: data.id})}
                  />
              </div>

              <div className="teacher-benefit-detail">
                  <div className="detail_item">
                      <p>مبلغ</p>
                      <p>{data?.amount}</p>
                  </div>
                  <div className="detail_item">
                      <p>تاریخ</p>
                      <p>{data?.issue_date}</p>
                  </div>
              </div>

              <div className="teacher-benefit-detail">
                  <div className="detail_item">
                      <p>تایید کننده</p>
                      <p>{data?.verified_by_staff_name}</p>
                  </div>
                  <div className="detail_item">
                      <p>ثبت کننده</p>
                      <p>{data?.modified_by_staff_name}</p>
                  </div>
              </div>

              <div className="teacher-benefit-detail summary">
                  <div className="detail_item">
                      <p>ملاحظه</p>
                      <p>{data?.remark}</p>
                  </div>
              </div>

          </div>
      </div>
  ) : null;
};

export default BenefitDetails;
